import { useSnackbar } from 'notistack';
import { useMutation } from 'react-query';
import { useService } from 'shared/providers';

export function useUploadParameters() {
    const { parameterService } = useService();
    const { enqueueSnackbar } = useSnackbar();

    const mutation = useMutation<void, Error, void>(() => parameterService.uploadParameters(), {
        onSuccess: async () => {
            enqueueSnackbar('Model scenario complete. Check email for results.', { variant: 'success' });
        },
        onError: async () => {
            enqueueSnackbar('Failed to run model scenario.', { variant: 'error' });
        },
    });
    return mutation;
}
